import { render, staticRenderFns } from "./InterviewFeedbackForm.vue?vue&type=template&id=22cbbc2a&scoped=true&"
import script from "./InterviewFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./InterviewFeedbackForm.vue?vue&type=script&lang=js&"
import style0 from "./InterviewFeedbackForm.vue?vue&type=style&index=0&id=22cbbc2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cbbc2a",
  null
  
)

export default component.exports